import React from 'react';
import { Grid } from '@mui/material';
import { DS_spacing as coreSpacing } from 'mui/base/theme/DS_Tokens/core';
import DS_MaxWidthLayout from '../DS_MaxWidthLayout';
import { StyledBox } from './DS_GridStyles';

/**
 *
 * @param {React.ReactNode} children
 * @param {String | React.FC} [component]
 *
 * @returns {React.ReactElement}
 */

const ResponsiveGrid = ({
  children,
  marginbottom = 0,
  marginsides = coreSpacing['rem']['xxxl'],
  direction = 'row',
  spacing = 20,
  columns = 12,
  justifyContent,
  alignItems,
}) => {
  return (
    <DS_MaxWidthLayout>
      <StyledBox sx={{ flexGrow: 1 }} marginbottom={marginbottom} marginsides={marginsides}>
        <Grid
          data-test="main-grid"
          container
          direction={direction}
          spacing={spacing}
          columns={columns}
          justifyContent={justifyContent}
          alignItems={alignItems}
        >
          {children}
        </Grid>
      </StyledBox>
    </DS_MaxWidthLayout>
  );
};

export default ResponsiveGrid;
